// @flow

// Libs
import React, { Component } from 'react'

// Messages
import messages from '../messages'
import { FormattedMessage } from 'react-intl'

// Constants
import {
  LARGE_SIZE,
  SORT_AS_NUMBER,
} from 'fc-component-datatable'
import {
  ATTR_LAST,
  ATTR_FIRST,
  ATTR_USERNAME,
  ATTR_PHONE,
  ATTR_EMAIL,
} from '../constants'

// Props type
type Props = {
  children?: any,
  mobile: boolean,
}

function translate (column: Object): React.Element<any> {
  return <FormattedMessage {...messages[column.attr]} />
}

// Exports
export default function usersTable (UserDataTable: Function): Function {
  return class UsersTable extends Component {
    props: Props
    renderer: { [string]: Function }

    render (): React.Element<any> {
      const columns = [
        { attr: ATTR_LAST, size: LARGE_SIZE, render: translate },
        { attr: ATTR_FIRST, size: LARGE_SIZE, render: translate },
        { attr: ATTR_USERNAME, size: LARGE_SIZE, render: translate },
        { attr: ATTR_PHONE, size: LARGE_SIZE, render: translate, sortAs: SORT_AS_NUMBER },
        { attr: ATTR_EMAIL, size: LARGE_SIZE, render: translate },
      ]

      return (
        <UserDataTable
          columns={columns}
          defaultColumn={ATTR_LAST}
          tools={this.props.children}
          mobile={this.props.mobile}
        />
      )
    }
  }
}
